import FormEditUserRolesBodyPermissions from './FormEditUserRolesBodyPermissions';
import FormEditUserRolesBodyRoot from './FormEditUserRolesBodyRoot';
import { useFormContext, useWatch } from 'react-hook-form';
import { SecuredComponent } from '@/components/hoc';
import { ToggleParam } from '@/components/custom';
import { Separator } from '@/components/ui';
import { useUserConnected } from '@/hooks';
import { TFormData } from '.';

const FormEditUserRolesBody = () => {

  const { control, formState: { isSubmitting }, setValue } = useFormContext<TFormData>();
  const root = useWatch({ control, name: 'roles.root' });
  let _id = useWatch({ control, name: '_id' });
  const { userConnected } = useUserConnected();

  const isCurrentUser = userConnected?._id === _id;

  return (
    <>
      <SecuredComponent permissionsRequired={() => false}>
        <ToggleParam
          title={'ROOT'}
          description={'Donne tous droits et permissions à l\'utilisateur.'}
          disabled={isCurrentUser || isSubmitting}
          switchColorOnChecked='#ef4444'
          checked={root}
          onCheckedChange={checked => setValue('roles.root', checked)}
          className='border-0 py-0 px-0 md:px-5' />
        <Separator className='text-red-500' />
      </SecuredComponent>
      {
        root
          ? <FormEditUserRolesBodyRoot />
          : <FormEditUserRolesBodyPermissions />
      }
    </>
  );

};

export default FormEditUserRolesBody;
